type Text = {
  // x: number;
  // y: number;
  // w: number;
  // h: number;
  text: string;
  fontSize: number;
  fontFamily: string;
  fontColor: string;
  moved?: boolean;
};

export const Text = class {
  text: Text;
  S: any;
  El: any;
  Width: number;
  Height: number;
  Center: { x: number; y: number };

  constructor(text: Text, S: any) {
    if (!text?.text) {
      return null;
    }

    this.text = text;
    this.S = S;
    this.El = null;
    this.Center = { x: 0, y: 0 };
  }

  place({ x = 0, y = 0 } = {}): this {
    if (!this.S) {
      return this;
    }

    this.El = this.S.text(0, 0, this.text.text);
    this.El.attr({
      fontSize: this.text.fontSize,
      fontFamily: this.text.fontFamily,
      color: this.text.fontColor,
      fill: this.text.fontColor,
    });

    const textBBox = this.El.node.getBBox();
    const printAreaBBox = this.S.node.querySelector('#printArea').getBBox();

    this.El.attr({
      x: this.text.moved ? x - textBBox.x : (printAreaBBox.width - textBBox.width) / 2 - textBBox.x + printAreaBBox.x,
      y: this.text.moved ? y - textBBox.y : (printAreaBBox.height - textBBox.height) / 2 - textBBox.y + printAreaBBox.y,
    });

    this.Center = { x: textBBox.width / 2, y: textBBox.height / 2 };

    this.Width = textBBox.width;
    this.Height = textBBox.height;

    return this;
  }

  remove(): void {
    this.El?.remove();
  }
};
